import {getAllUser} from '@/api/user.js'
import {WPauth,getauthuser} from '@/api/workplace.js'
import {getSearchParm} from "@/utils/index.js"
import {message} from 'ant-design-vue'

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)

const columns =[
	{dataIndex:"username",title:"姓名"},
	{dataIndex:"phonenum",title:"电话"},
	{dataIndex:"idcard",title:"身份证号"},
]

export default {
	data(){
		return {
			visible:false,
			columns,
			dataSource:[],
			alldataSource:[],
			selectedRowKeys:[],
			selectedRows:[],
			id:"",
			pagination:{
				pageSize:10,
			},
			callback:"",
			searchdata:getSearchParm({
				username:"",
				phonenum:"",
				idcard:""
			})
		}
	},
	watch:{
		selectedRowKeys(value){
			this.selectedRows = this.alldataSource.filter(item=>[...value].includes(item.id))
		}	
	},	
	props:[
	],
	methods:{
		saveauth(){
			this.visible = false
			let auth = this.selectedRowKeys
			let hide =  message.loading("正在处理",200)
			WPauth({
				id:this.id,mngs:auth
			}).then(ret=>{
				hide()
				if(ret.code == 0){
					this.callback()
					message.success("成功",1)
				}else{
					message.error("失败",1)
				}
			})
		},
		showAuth(record,callback){
			let {id} = record
			this.callback = callback	
			getauthuser({wid:id}).then(ret=>{
				if(ret.code == 0){
					let {data} = ret
					let slts  = data.map(item=>{
						return item.userid
					})
					this.selectedRowKeys = slts
					this.selectedRows = this.dataSource.filter(item=>{
						return slts.includes(item.id)
					})
				}
			})
			this.id = id
			this.visible = true
		},
		//用户列表
		getuser(parm){
			parm = {...parm,cmpid:user.cmpid}
		   return	getAllUser(parm).then(ret=>{
				if(ret.code === 0){
					let {data:{rows,count}} = ret
					this.dataSource = rows
					this.pagination = {...this.pagination,total:count}
					return rows
				}
			})
		},
		onSelectChange(slts){
			this.selectedRowKeys = slts
		},
		find(){
			this.getuser({...this.searchdata})
		}
	},
	mounted(){
		this.getuser().then(ret=>{
			this.alldataSource = [...ret]
		})
	}
}